import axios from "axios";

const REACT_APP_MICRO_CHAT_URL = process.env.REACT_APP_MICRO_CHAT_URL;

export const getParticipantId = (id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/participants/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_PARTICIPANT_BY_ID",
        data: response.data.data,
      });
    });
};
export const getParticipantByThreadId = (id) => (dispatch) => {
  axios
    .get(
      `${REACT_APP_MICRO_CHAT_URL}/participants/participants_by_thread/${id}`
    )
    .then((response) => {
      dispatch({
        type: "GET_PARTICIPANT_BY_THREAD_ID",
        data: response.data.data,
      });
    });
};
export const getParticipantsByThreadByUser =
  (thread_id, user_id) => (dispatch) => {
    axios
      .get(
        `${REACT_APP_MICRO_CHAT_URL}/participants/participants_by_thread/${thread_id}/${user_id}`
      )
      .then((response) => {
        dispatch({
          type: "GET_PARTICIPANT_BY_THREAD_ID_USER_ID",
          data: response.data.data,
        });
      });
  };
export const block_unblockParticipant = (id) => (dispatch) => {
  axios
    .patch(`${REACT_APP_MICRO_CHAT_URL}/participants/${id}`)
    .then(() => {
      dispatch({
        type: "BLOCK_UNBLOCK_PARTICIPANT_SUCCESS",
      });
    })
    .catch((err) => {
      dispatch({
        type: "BLOCK_UNBLOCK_PARTICIPANT_FAILED",
        payload: err.response,
      });
    });
};
export const insertParticipant = (data) => (dispatch) => {
  axios
    .post(`${REACT_APP_MICRO_CHAT_URL}/participants`, data)
    .then((response) => {
      dispatch({
        type: "INSERT_PARTICIPANT_SUCCESS",
        payload: response.data.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: "INSERT_PARTICIPANT_FAILED",
        payload: err.response,
      });
    });
};
